import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9])

    return (
        <>
            {state.map(info =>
                <div className="skltn-recomand">
                    <Skeleton animation="wave" width={100+'%'} height={330} />
                </div>
            )}
        </>
    );
}

export default Skltn;